import { createTheme } from '@material-ui/core/styles';

const Theme = createTheme({
  typography: {
    fontSize: 18,
    fontFamily: ['Lato'].join(','),

    h1: {
      fontSize: 32,
      lineHeight: '40px',
      lineSpacing: '-4%',
      fontWeight: 'bold',
      cursor: 'default',

      '@media (min-width: 780px)': {
        fontSize: 64,
        lineHeight: '70px',
      },
      fontFamily: ['Lexend'].join(','),
    },
    h2: {
      fontSize: 24,
      lineHeight: '32px',

      fontWeight: 'bold',

      '@media (min-width: 780px)': {
        fontSize: 48,
        lineHeight: '46px',
      },
      fontFamily: ['Lexend'].join(','),
      cursor: 'default',
    },
    h3: {
      fontSize: 20,
      lineHeight: '30px',

      fontWeight: 'bold',
      '@media (min-width: 780px)': {
        fontSize: 24,
        lineHeight: '34px',
      },
      fontFamily: ['Lexend'].join(','),
      cursor: 'default',
    },

    subtitle1: {},
    subtitle2: {
      fontSize: 12,
      cursor: 'default',
    },

    body1: {
      fontSize: 16,
      lineHeight: '26px',
      fontFamily: ['Lato'].join(','),
      '@media (min-width: 780px)': {
        fontSize: 18,
        lineHeight: '30px',
      },
      cursor: 'default',
    },
    body2: {
      fontSize: 16,
      lineHeight: '26px',
      fontFamily: ['Lato'].join(','),
      cursor: 'default',
    },
  },
  palette: {
    text: {
      primary: '#4E3D66',
      secondary: '#5C556D',
    },
    primary: {
      dark: '#8244E1',
      main: '#6D28D7',
      light: '#F0EAF8',
      contrastText: '#FFFFFF',
    },
    secondary: {
      dark: '#FFD016',
      main: '#FFD738',
      light: '#F2F0FE',
      contrastText: '#884DE0',
    },
    background: {
      paper: '#FFFFFF',
    },
    grey: {
      '100': '#242424',
      '200': '#4E3D66', // gray1
      '300': '#7780A0',
      '400': '#bfbfbfcc',
      '500': '#7A6D8F', // gray2
      '600': '#EBECF4',
      '700': '#DEDCE0', // gray3
      '800': '#F8F8FC',
      '900': '#FDFDFF',
    },
    success: {
      dark: '#209E53',
      main: '#25B860',
      light: '#2AD16D',
    },
    error: {
      dark: '#DB3D3D',
      main: '#F64545',
      light: '#FF5C5C',
    },
    info: {
      dark: '#1877F2',
      main: '#2B93F2',
      light: 'rgba(73, 165, 250, 1)',
    },
    warning: {
      dark: '#E58200',
      main: '#FF9000',
      light: '#FFA633',
    },
  },
  overrides: {
    MuiInput: {
      underline: {
        '&&&&:hover:before': {
          borderBottom: 'none',
        },
      },
    },
    MuiButton: {
      root: {
        textTransform: 'capitalize',
        borderRadius: 8,
        color: '#fff',
        backgroundColor: '#884DE0',
        '&:hover': {
          backgroundColor: '#5924A7',
        },
      },
    },
  },
});

export default Theme;
